'use strict';

const inspectableError = require('../rlink-inspectable-error');

module.exports = function _throwOnUpdateScalar (obj, ops, coveredPath) {
  console.group('ERROR: UPDATING SCALAR');
  for (let [path, op, value] of ops) {
    console.log(`${path.join('.')} ${op.toString()}`, value);
  }
  console.groupEnd();
  throw inspectableError`Can't update scalar ${{obj}} at ${coveredPath.map(String).join('.')} (${ops})`;
};



// WEBPACK FOOTER //
// ./lib/rlink-collections/_throwOnUpdateScalar.js